import { render, staticRenderFns } from "./Profile.ProductRequests.vue?vue&type=template&id=219b41fd&scoped=true"
import script from "./Profile.ProductRequests.vue?vue&type=script&lang=js"
export * from "./Profile.ProductRequests.vue?vue&type=script&lang=js"
import style0 from "./Profile.ProductRequests.vue?vue&type=style&index=0&id=219b41fd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "219b41fd",
  null
  
)

export default component.exports